import { StickersCode } from '@shared/const/stickers';
import { badgesProductTypes, StickerType } from '../../types/actionSchema';

export type DistributionStickersTypeProps = {
  leftStickers: badgesProductTypes[];
  rightStickers: badgesProductTypes[];
};

export enum TypeDistributionStickers {
  Default = 'default',
  LeftWarranty = 'left-warranty',
}

function defaultDistribution(
  stickers: badgesProductTypes[],
  arrayLeft,
  arrayRight,
): {
  leftStickers: badgesProductTypes[];
  rightStickers: badgesProductTypes[];
} {
  for (let i = 0; i < stickers?.length; i++) {
    if (stickers[i].code === StickersCode.Storage) {
      continue;
    }
    if (stickers[i].code === StickersCode.FreeTireFitting) {
      arrayRight.push(stickers[i]);
      continue;
    }
    if (stickers[i].type === StickerType.Actions) {
      arrayLeft.push(stickers[i]);
    } else if (stickers[i].type === StickerType.Warranties) {
      arrayRight.push(stickers[i]);
    }
  }

  return {
    leftStickers: arrayLeft,
    rightStickers: arrayRight,
  };
}

function LeftWarrantyDistribution(
  stickers: badgesProductTypes[],
  arrayLeft,
  arrayRight,
): {
  leftStickers: badgesProductTypes[];
  rightStickers: badgesProductTypes[];
} {
  for (let i = 0; i < stickers?.length; i++) {
    if (stickers[i].code === StickersCode.FreeTireFitting) {
      arrayRight.push(stickers[i]);
      continue;
    }
    if (stickers[i].code === StickersCode.Storage) {
      continue;
    }
    if (stickers[i].type === StickerType.Actions) {
      arrayRight.push(stickers[i]);
    } else if (stickers[i].type === StickerType.Warranties) {
      arrayLeft.push(stickers[i]);
    }
  }

  return {
    leftStickers: arrayLeft,
    rightStickers: arrayRight,
  };
}

export function distributionStickers(
  stickers: badgesProductTypes[],
  type: TypeDistributionStickers = TypeDistributionStickers.Default,
): DistributionStickersTypeProps {
  const arrayLeft = [];
  const arrayRight = [];
  switch (type) {
    case TypeDistributionStickers.LeftWarranty:
      return LeftWarrantyDistribution(stickers, arrayLeft, arrayRight);
    default:
      return defaultDistribution(stickers, arrayLeft, arrayRight);
  }
}
